import React, {useState} from 'react';
import Leaflet from 'leaflet';
import {TileLayer, Marker, useMapEvents} from 'react-leaflet'

import {useToast} from '../../../common/hook/toast';

import RoutineMachine from './RoutineMachine';

import {Button} from 'react-bootstrap';

import ImgMarker from '../../../asset/img/map/marker.svg'
import ImgMarkerMicaMall from '../../../asset/img/map/marker-micamall.svg'
import {ReactComponent as ImgDirection} from '../../../asset/img/icon/direction.svg';
import {ReactComponent as ImgLoader} from '../../../asset/img/icon/loader-animation.svg';
import {ReactComponent as ImgLogoSign} from '../../../asset/img/micamall-logo-sign.svg';

import * as IconFi from 'react-icons/fi';
import * as IconTb from 'react-icons/tb';

const iconMicaMall = new Leaflet.Icon({
    iconUrl: ImgMarkerMicaMall,
    iconAnchor: null,
    iconSize: [48, 48],
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    className: 'mica-mall'
});

const iconLocation = new Leaflet.Icon({
    iconUrl: ImgMarker,
    iconAnchor: null,
    iconSize: [48, 48],
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    className: 'mica-mall'
});

const Map = props => {
    const {callToast} = useToast()

    // -----------------------------------------------------------------------------------------------------------------

    const [btnDirection, setBtnDirection] = useState(null)
    const [showRoute, setShowRoute] = useState(false)

    const map = useMapEvents({
        locationfound: e => {
            if (!btnDirection || (btnDirection && e.latitude !== btnDirection[0] && e.longitude !== btnDirection[1]))
                setBtnDirection([e.latitude, e.longitude]);
        },
        locationerror: e => {
            callToast('secondary', null, null, 'موقعیت شما یافت نشد');
        }
    })

    const setCurrentLocationHandler = e => {

        if (e.target.closest('.btn').id === 'btnCurrentLocation') {

            map.locate({setView: true})

        } else if (e.target.closest('.btn').id === 'btnMicaMall') {

            map.setView(props.data.center, props.data.zoom);

        } else if (e.target.closest('.btn').id === 'btnDirection') {

            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:first-child').classList.add('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:nth-child(2)').classList.remove('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:last-child').classList.add('d-none')

            if (showRoute) {

                setShowRoute(false)

                let timeout = setTimeout(() => {

                    clearTimeout(timeout)

                    setShowRoute(true)

                }, 0)

                return

            }

            setShowRoute(true)

        } else if (e.target.closest('.btn').id === 'btnDirectionClose') {

            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:first-child').classList.remove('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:nth-child(2)').classList.add('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:last-child').classList.add('d-none')

            setShowRoute(false)

        }

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
            <Marker position={props.data.center} icon={iconMicaMall}/>
            {
                btnDirection ? (
                    <Marker position={btnDirection} icon={iconLocation}/>
                ) : (
                    <></>
                )
            }
            {
                showRoute && btnDirection ? (
                    // <RoutineMachine data={[props.data.center, [26.53306, 54.02471], map]}/>
                    <RoutineMachine data={[props.data.center, btnDirection, map]}/>
                ) : (
                    <></>
                )
            }
            {
                btnDirection ? (
                    <div id="divRoute" className="position-absolute">
                        <Button id="btnDirection" variant="link" className="btn-icon bg-elevate-2 text-white shadow" onClick={setCurrentLocationHandler}><ImgDirection className="sw-1"/></Button>
                        <Button variant="link" className="btn-icon bg-elevate-2 shadow d-none"><ImgLoader width={24} height={24} className="sw-1 svg-loader"/></Button>
                        <Button id="btnDirectionClose" variant="link" className="btn-icon bg-elevate-2 text-white shadow d-none" onClick={setCurrentLocationHandler}><IconFi.FiX size={24} className="sw-1"/></Button>
                    </div>
                ) : (
                    <></>
                )
            }
            <Button id="btnCurrentLocation" variant="link" className="btn-icon position-absolute bg-elevate-2 text-white shadow" onClick={setCurrentLocationHandler}><IconTb.TbCurrentLocation size={24} className="sw-1"/></Button>
            <Button id="btnMicaMall" variant="link" className="btn-icon position-absolute bg-primary shadow" onClick={setCurrentLocationHandler}><ImgLogoSign/></Button>
        </>
    )
}

export default Map;